import axios from 'axios';

const cp = axios.create({ headers: { 'Content-Type': 'application/json' } });

cp.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const E = (key) => process.env[key] || '';

export const cpApi = {
  getConfidenceScore: (payload) =>
    cp.post(E('REACT_APP_CONTROLPLANE_GETCONFIDENCESCORE'), payload),

  getRisks: (payload) =>
    cp.post(E('REACT_APP_CONTROLPLANE_GETRISKS'), payload),
  createRisk: (payload) =>
    cp.post(E('REACT_APP_CONTROLPLANE_CREATERISK'), payload),
  updateRisk: (payload) =>
    cp.put(E('REACT_APP_CONTROLPLANE_UPDATERISK'), payload),
  resolveRisk: (payload) =>
    cp.post(E('REACT_APP_CONTROLPLANE_RESOLVERISK'), payload),

  getSignals: (payload) =>
    cp.post(E('REACT_APP_CONTROLPLANE_GETSIGNALS'), payload),
  createSignal: (payload) =>
    cp.post(E('REACT_APP_CONTROLPLANE_CREATESIGNAL'), payload),

  getIntentGraph: (payload) =>
    cp.post(E('REACT_APP_CONTROLPLANE_GETINTENTGRAPH'), payload),
  createNode: (payload) =>
    cp.post(E('REACT_APP_CONTROLPLANE_CREATEINTENTNODE'), payload),
  createEdge: (payload) =>
    cp.post(E('REACT_APP_CONTROLPLANE_CREATEINTENTEDGE'), payload),

  getPolicies: (payload) =>
    cp.post(E('REACT_APP_CONTROLPLANE_GETPOLICIES'), payload),
  updatePolicy: (payload) =>
    cp.put(E('REACT_APP_CONTROLPLANE_UPDATEPOLICY'), payload),

  getAudit: (payload) =>
    cp.post(E('REACT_APP_CONTROLPLANE_GETAUDIT'), payload),

  getAutonomyLevel: (payload) =>
    cp.post(E('REACT_APP_CONTROLPLANE_GETAUTONOMYLEVEL'), payload),
  updateAutonomyLevel: (payload) =>
    cp.put(E('REACT_APP_CONTROLPLANE_UPDATEAUTONOMYLEVEL'), payload),
};

export default cpApi;
